export default __webpack_public_path__ + "static/media/12.32802bf9.png";